import {
  routerPostCall,
  routerGetCall,
  strapiGetCall,
  strapiPostCall,
  routerPatchCall,
  routerPutCall,
  routerDeleteCall,
} from '../../axios';

const apiCallWizard = (state, url, params, httpMethod, opts) => {
  if (httpMethod === 'routerGet') {
    // let newParams = params;
    // if (params && Object.keys(params).length > 0) {
    //  newParams = {};
    //  Object.keys(params).forEach(x => {
    //    const newX = encodeURIComponent(x);
    //    newParams[newX] = encodeURIComponent(params[x]);
    //  });
    // }
    return routerGetCall(state, url, params, opts); // newParams
  }
  if (httpMethod === 'routerPost') {
    return routerPostCall(state, url, params, opts);
  }
  if (httpMethod === 'strapiGet') {
    return strapiGetCall(state, url, params);
  }
  if (httpMethod === 'strapiPost') {
    return strapiPostCall(state, url, params);
  }
  if (httpMethod === 'routerPatch') {
    return routerPatchCall(state, url, params, opts);
  }
  if (httpMethod === 'routerPut') {
    return routerPutCall(state, url, params, opts);
  }
  if (httpMethod === 'routerDelete') {
    return routerDeleteCall(state, url, params, opts);
  }
  return Promise.resolve(null);
};
export default { apiCallWizard };